export class ExtPromise<T>
{
    public resolve: (result:T) => void;
    public reject: (error:any) => void;
    public readonly promise: Promise<T>;

    constructor()
    {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}